// https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
const EMAIL_REGEX =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export function validateEmail(value: string = "", forMethod: "signup" | "login"): [boolean, string | undefined] {
	if (value.trim().length === 0) {
		return [false, undefined];
	}
	const valid = value.match(EMAIL_REGEX);

	// We don't support the plus ("+") sign in email addresses in signup.
	// However, we have more than 7,000 existing users with a plus sign so we allow it in during login.
	if (valid && !(forMethod == "signup" && value.includes("+"))) {
		return [true, undefined];
	}

	return [false, "Your email address is invalid"];
}

export function validatePassword(value: string = "") {
	return value.trim().length > 0;
}

export function validateFirstName(value: string = ""): [boolean, string | undefined] {
	if (value.trim().length === 0) {
		return [false, undefined];
	}
	if (value.trim().length > 15) {
		return [false, "First name is too long"];
	}

	return [true, undefined];
}

export function validateLastName(value: string = ""): [boolean, string | undefined] {
	if (value.trim().length === 0) {
		return [false, undefined];
	}
	if (value.trim().length > 15) {
		return [false, "Last name is too long"];
	}

	return [true, undefined];
}
